var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"100%","height":"400px","padding":"10px"}},[_c('img',{staticStyle:{"width":"100%","height":"100%","padding":"0","margin-left":"-7px"},attrs:{"src":_vm.urlPath}})])
}
var staticRenderFns = []

export { render, staticRenderFns }